import { useState, useEffect } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

export default function ApplicationStatusModal({ show, onClose, applicationId, data, setData }) {
    const [status, setStatus] = useState("");
    const [comment, setComment] = useState("");

    useEffect(() => {
        if (!applicationId) return;
        const app = data.find(d => d._id === applicationId);
        if (app) {
            setStatus(app.application_status?.toString() || "");
            setComment(app.comment || "");
        }
    }, [applicationId, data]);

    if (!show) return null;

    const submitHandler = async () => {
        if (status === "") return alert("Select status");

        try {
            const res = await ApiRequest("POST", ApiEndpoints.jobApplication.StatusUpdate, {
                application_id: applicationId,
                application_status: Number(status),
                comment,
            });

            console.log("Update API response:", res); // Debug: check if backend saved correctly

            if (res.error == true) {
                alert("Backend failed to save status/comment. Check logs.");
                return;
            }

            // Local table update
            setData(prev =>
                prev.map(item =>
                    item._id === applicationId ? { ...item, application_status: Number(status), comment } : item
                )
            );

            alert("Status & Comment Updated ✅");
            onClose();
        } catch (error) {
            console.error("API update error:", error);
            alert("Failed to update status/comment. Check console.");
        }
    };

    return (
        <div className="modal-backdrop-custom">
            <div className="modal-custom">
                <h5>Update Application Status</h5>
                <select className="form-control mt-2" value={status} onChange={e => setStatus(e.target.value)}>
                    <option value="">Select</option>
                    <option value="0">Pending</option>
                    <option value="1">Approved</option>
                    <option value="2">Rejected</option>
                    <option value="3">In Progress</option>
                </select>
                <textarea
                    className="form-control mt-2"
                    placeholder="Comment"
                    value={comment}
                    onChange={e => setComment(e.target.value)}
                />
                <div className="mt-3 text-end">
                    <button className="btn btn-secondary me-2" onClick={onClose}>Cancel</button>
                    <button className="btn btn-success" onClick={submitHandler}>Submit</button>
                </div>
            </div>
        </div>
    );
}
